import React from "react";
import MxTypography from "../../../MxTypography";
import { Grid } from "@mui/material";
import { EFontFamilies } from "@/shared/theme/theme";
interface MxCPropertyPriceProps {
  label: string;
  value: string;
}
const MxCPropertyPrice = (props: MxCPropertyPriceProps) => {
  return (
    <Grid container rowGap={0.2} alignItems="center" columnSpacing={0.5}>
      <Grid item xs="auto">
        <MxTypography
          variant="caption"
          color="grey.700"
          fontWeight={300}
          fontFamily={EFontFamilies.SECONDARY_FONT}
          textTransform="uppercase"
          sx={{
            fontSize: "11.5px !important"
          }}
        >
          {props.label}
        </MxTypography>
      </Grid>
      <Grid item xs="auto">
        <MxTypography
          variant="caption"
          color="error.main"
          fontWeight={600}
          fontSize={12}
          fontFamily={EFontFamilies.DEFAULT_FONT}
        >
          {props.value}
        </MxTypography>
      </Grid>
    </Grid>
  );
};

export default MxCPropertyPrice;
